import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './level-control.controller';
import directive from './level-control.directive';


export default angular.module('app.components.advisory.ecat.levelControl', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('ecatLevelControl', directive)
  .controller('LevelControlController', controller)
  .name;

console.log('app.components.advisory.ecat.levelControl created');
